<h2 mat-dialog-title>Solution + Report</h2>
<mat-dialog-content class="mat-typography">
  
         
  <!-- Old naming method-->
  <span *ngIf="data.question.paper_id >= 11 && data.question.paper_id < 35">
    <p><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/v1580972158/bio/{{data.question.folder_name}}_Q{{data.question.question_no}}_{{data.lang}}_S.png"></p>
  </span>
  <!-- New naming method-->
  <span *ngIf="data.question.paper_id < 11 || data.question.paper_id >= 35">
    <p><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/v1580972158/bio/{{data.question.folder_name}}/{{data.question.folder_name}}_Q{{data.question.question_no}}_A__{{data.lang}}.png"></p>
     </span>
  <span *ngIf="data.question.paper_id < 11 || data.question.paper_id >= 24">
       <p><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/v1580972158/bio/{{data.question.folder_name}}/{{data.question.folder_name}}_Q{{data.question.question_no}}_R__{{data.lang}}.png"></p>
    </span>
</mat-dialog-content>
